export default [
    // *===============================================---*
    // *--------- USER ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/account',
        name: 'apps-users-edit',
        component: () => import('@/views/company/user/users-edit/UsersEdit.vue'),
        // No pageTitle/breadcrumb: the page card shows the title (avoids a duplicate header)
        meta: {}
    },
    {
        path: '/workspace',
        name: 'workspace',
        component: () => import('@/views/pages/authentication/WorkspaceV2.vue'),
        meta: {
            layout: 'full',
            pageTitle: 'Workspace',
            resource: 'Workspace',
            action: 'read',
        }
    },
]